import React from 'react';
import LearnerSidebar from './LearnerSidebar';
import LearnerHeader from './LearnerHeader';

const LearnerLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-white">
      <LearnerHeader />
      <LearnerSidebar />
      <main className="lg:pl-64 pt-[72px] min-h-screen">
        <div className="p-5 lg:p-8">
          {children}
        </div>
      </main>
    </div>
  );
};

export default LearnerLayout;
